import React from 'react'
import Html from 'react-pdf-html';
import { Page, Document } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import moment from "moment"
import 'moment/locale/es';

export default function PDFPSPM({ data }) {

    const removeCharacters = (str) => {
        if (!str) {
            return ""
        }

        str  = String(str)
        return str.replace('<', '').replace('>', '')
    }

    const html = `<html>
    <head>
        <style>
                  table{
                    border: 1px solid #000000;
                  }

                  *{
                    font-size:12px;
                  }

                  td {
                        padding: 5px;
                    }
                    .bold{
                        font-weight:bold;
                        color:#020a5b;
                    }
                    img{
                        height:90px;
                        width:400px;
                    }
            </head>
        </style>
    </head>
    <body style="padding: 25px;">
        <div style="padding-left:55px">
            <img src="/headerpdf.png"/>
        </div>
        <p style="text-align: center;">
        Denuncia actos de corrupción o faltas administrativas de personas
        servidoras públicas del Municipio de Chihuahua y/o personas físicas
        o morales privadas vinculados con actos de gobierno del Municipio,
        conforme lo establece la Ley General de Responsabilidades
        Administrativas.
        </p>
        <br />
        <table style="width: 100%;">
            <thead></thead>
            <tbody>
                <tr>
                    <td colspan="3">
                    Los datos personales por usted proporcionados serán protegidos en términos del artículo 134 de la Ley de Transparencia y Acceso a la Información Pública del Estado de Chihuahua, así como los datos personales que se recaben en el presente expediente y se registrarán en los controles internos, cuya finalidad es supervisar, controlar y dar seguimiento a la atención que se brinde a las denuncias presentadas, lo anterior con fundamento en los artículos artículos 1, 9 fracc. II y 10 de la Ley General de Responsabilidades Administrativas y 28 fracc. X, 100 fracc. XXX, 101 inciso V, 101 bis inciso VI, del Reglamento Interior del Municipio de Chihuahua.
                    </td>
                </tr>
            </tbody>
        </table>
        <p>Datos de la persona servidora pública denunciada y/ó particulares vinculados con faltas administrativas graves:</p>
        <table style="width: 100%;">
            <thead></thead>
            <tbody>
                <tr>
                    <td>Nombre(s)</td>
                    <td class="bold">${data.info.name_pspm}</td>
                </tr>
                <tr>
                    <td>Cargo(s):</td>
                    <td class="bold">${data.info.data_pspm}</td>
                </tr>
                <tr>
                    <td>Lugar de adscripción</td>
                    <td class="bold">${data.info.place_pspm}</td>
                </tr>
            </tbody>
        </table>
        <p>Narración de los hechos:</p>
        <table style="width: 100%;">
            <thead></thead>
            <tbody>
                <tr>
                    <td>¿Cuándo ocurrieron los hechos?</td>
                </tr>
                <tr>
                    <td class="bold">${moment(data.info.date_event).format("LL")}</td>
                </tr>
                <tr>
                    <td>¿Dónde ocurrieron los hechos?</td>
                </tr>
                <tr>
                    <td class="bold">${removeCharacters(data.info.where_event)}</td>
                </tr>
                <tr>
                    <td>¿Cómo ocurrieron los hechos?</td>
                </tr>
                <tr>
                    <td class="bold">${removeCharacters(data.info.how_event)}</td>
                </tr>
                <tr>
                    <td class="">¿Existen pruebas de los hechos?</td>
                    <td class="bold" colspan="2">${data.info.proof == 1 ? "Si" : "No"}</td>
                </tr>
                <tr>
                    <td colspan="3">Precisar:</td>
                </tr>
                <tr>
                    <td colspan="3" class="bold">${removeCharacters(data.info.prooftext) || ""}</td>
                </tr>
                <tr>
                    <td class="">¿Tiene testigos de los hechos?</td>
                    <td class="bold" colspan="2">${data.info.witness == 1 ? "Si" : "No"}</td>
                </tr>
                <tr>
                    <td class="">Nombre</td>
                    <td class="">Domicilio/Correo Electrónico</td>
                    <td>Teléfono</td>
                </tr>                
                ${data.witness.map((witness) => {
        return "<tr><td class='bold'>" + removeCharacters(witness.name) + "</td><td class='bold'>" + removeCharacters(witness.data) + "</td><td class='bold'>" + removeCharacters(witness.phone) + "</td></tr>"
    })
        }
            </tbody>
        </table>
        <p>Datos de la persona denunciante:</p>
        <table style="width: 100%;">
            <thead></thead>
            <tbody>
                <tr>
                    <td>Nombre</td>
                    <td>Apellido Paterno</td>
                    <td>Apellido Materno</td>
                </tr>

                <tr>
                    <td class="bold">${removeCharacters(data.info.names) || ""}</td>
                    <td class="bold">${removeCharacters(data.info.p_lastname) || ""}</td>
                    <td class="bold">${removeCharacters(data.info.m_lastname) || ""}</td>
                </tr>
                <tr>
                    <td colspan="3">Calle: <span class="bold">${removeCharacters(data.info.street) || ""}</span></td>
                </tr>
                <tr>
                    <td>Colonia</td>
                    <td>Municipio</td>
                    <td>Código Postal</td>
                </tr>
                <tr>
                    <td class="bold">${removeCharacters(data.info.colony) || ""}</td>
                    <td class="bold">${removeCharacters(data.info.mpo) || ""}</td>
                    <td class="bold">${removeCharacters(data.info.cp) || ""}</td>
                </tr>
                <tr>
                    <td>Teléfono</td>
                    <td>Correo Electrónico</td>
                    <td>Entidad Federativa</td>
                </tr>
                <tr>
                    <td class="bold">${removeCharacters(data.info.phone)}</td>
                    <td class="bold">${removeCharacters(data.info.email)}</td>
                    <td class="bold">${removeCharacters(data.info.ef)}</td>
                </tr>
            </tbody>
        </table>
        <br/>
        <strong>Notas:</strong>
        <p>
        1.- En caso de requerir asesoría para el llenado de este formato, favor de comunicarse al teléfono 614 200 4800 ext. 6627,
        de lunes a viernes de 8:30 a 16;00 horas y con gusto le atenderemos, 
        </p>
        <p>
        2.- Es muy importante que nos proporciones sus datos y estar en posibilidad de contactarlo a efecto de darle a conocer la
        situación de la denuncia presentada y en su caso, obtener mayores elementos durante la integración de la
        investigación.
        </p>
    </body>
</html>
`;

    const posts = data.proof.map((proof, i) => (
        <a href={proof.routeimage} target='_blank' rel="noreferrer" download>
            <img key={i} className="img-fluid" src={proof.routeimage} alt='Pruebas' />
        </a>
    ));
    
    return (
        <div className="reportView">
            <PDFViewer>
                <Document>
                    <Page>
                        <Html>{html}</Html>
                    </Page>
                </Document>
            </PDFViewer>
            {data.proof.length > 0 && <h4 className='text-center'>Pruebas de la denuncia (dar clic para ver mas grande)</h4>}
            <div className="containerImages">
                {posts}
            </div>
        </div>
    );
}